import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    first: String,
    second: String
  }

  confirm(event) {
    const first = this.firstValue || "Are you sure?"
    const second = this.secondValue || "This cannot be undone. Confirm?"

    if (!window.confirm(first)) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }

    if (!window.confirm(second)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }
}
